import DashBoardNav from '@/layout/DashBoardNav'


export default [{
  path: '/empresas',
  component: DashBoardNav ,
  children: [{
    path: '/empresas/filtro-basico',
    component: () => import('@/components/empresas/filtroBasico')
  }]
}]
